<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>项目经历</h1>
            </el-col>
            <el-col :span="20">
                <el-row v-for="item in resumeInfo.projectExperienceList" :key="item.id">
                    <el-col :span="12"><b>{{item.projectName}}</b></el-col>
                    <el-col :span="12"> {{item.startTime}} ~ {{item.endTime}}</el-col>

                    <el-col :span="12">
                        <span>公司名称：</span>{{item.company}}
                    </el-col>
                    <el-col :span="12">
                        <span>担当角色：</span><span>{{item.roleName}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span>项目描述：</span>{{item.description}}
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: 'ProjectExperience',
        props: ['resumeInfo'],
    }
</script>